<template>
  <ul class="hp-trust-strip">
    <li>
      <v-icon class="hp-trust-strip__icon" size="20">{{ $icons.accountMultiple }}</v-icon>
      <span><strong>3M+</strong> job seekers</span>
    </li>
    <li>
      <v-icon class="hp-trust-strip__icon" size="20">{{ $icons.layers }}</v-icon>
      <span><strong>5000+</strong> companies</span>
    </li>
    <li>
      <v-icon class="hp-trust-strip__icon" size="20">{{ $icons.starCircle }}</v-icon>
      <span><strong>40%</strong> higher shortlist rate</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'HomeTrustStrip',
};
</script>
